const pubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCoTkDtVkk+/rR4QeKV4nFZbf8zNUqrcB6BbTa9L8PAqE5pciYzxDKPRy0QN9FEwu6dVoTT+2nrO3f3nIT2RL0XkwGkMaO1LT9khTLkD605ReIzs23O0YYisBOPPHtXJE64qZXyeJ/J+jWL7B3EU4f+KNr0oS7BfccHW69BU6PUawIDAQAB'

/** 文件上传 */
const imgUrl = 'https://static.lux360.cn'
const uploadUrl = 'https://image.lux360.cn'

/** 开发环境 */
// const baseURL = 'http://127.0.0.1:8081'
const baseURL = ''

/** 测试环境 */
const webURL = 'http://wx.91lux.cn'
  // const baseURL = 'https://mobile.91lux.cn'
const appID = 'wx959b46d1043cc33e'

export default {
  pubKey,
  imgUrl,
  uploadUrl,
  webURL,
  baseURL,
  appID,
  modelName:'',
  modelPrice:'',
  modelId:'',
  update_id:'',
  homeCity: {
    city_id: 0,
    city_name: '全国'
  },
  city: {
    city_id: '',
    city_name: ''
  },

}



// WEBPACK FOOTER //
// ./src/global.js